export default {
  allFeaturesList: [],
  addedFeaturesList: [],
  addedFeaturesListLoading: false,
  addedFeaturesListLoaded: false,
  allCategoriesFeaturesList: [],
};
